import React from 'react';
import { Switch, Route } from 'react-router-dom';

import List from './List';
import Form from './Form';

const Category: React.FC = () => {
  return (
    <Switch>
      <Route path="/categories" component={List} isPrivate exact />
      <Route path="/categories/add" component={Form} isPrivate />
      <Route path="/categories/edit/:id" component={Form} isPrivate />
    </Switch>
  );
};

export default Category;
